"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var React = require("react");
var ReactDom = require("react-dom");
var util_1 = require("~/js/lib/util/util");
var then_ajax_1 = require("then-ajax");
var theme_1 = require("~@/widget/theme/theme");
var stat_1 = require("../stat/stat");
require("./udb.scss");
var UDB_EL_ID = 'yyHeaderLoginBox';
var IS_WIN = (navigator.platform === 'Win32') || (navigator.platform === 'Windows');
var IS_WIN_XP = navigator.userAgent.indexOf('Windows NT 5.1') > -1 || navigator.userAgent.indexOf('Windows Xp') > -1;
var INTERFACE = {
    GET_AUTH: theme_1.DOMAIN + "/login/getSdkAuth?embed=true&cssid=5719_1",
    LOGOUT: theme_1.DOMAIN + "/login/logout",
    LOGIN_CB: theme_1.DOMAIN + "/login/udbCallback",
    REG_CB: theme_1.DOMAIN + "/web/yycom_header/3rd-login/reg-login.html",
    QQ_CB: theme_1.DOMAIN + "/3rdLogin/qq-login.html",
    WB_CB: theme_1.DOMAIN + "/web/yycom_header/3rd-login/wb-login.html",
    WX_CB: theme_1.DOMAIN + "/web/yycom_header/3rd-login/wx-login.html?jump_url=" + window.location.href
};
var HOST_NAME = window.location.hostname;
var APP_MAP = {
    'xn.yy.com': 6220,
    'xntest.yy.com': 6219,
    'web.yy.com': 6217,
    'webtest.yy.com': 6218
};
var APPID = APP_MAP[HOST_NAME];
if (APPID) {
    INTERFACE.GET_AUTH = "//" + HOST_NAME + "/udbweb/init/" + APPID;
    INTERFACE.LOGIN_CB = "//" + HOST_NAME + "/udbweb/callback/" + APPID;
    INTERFACE.LOGOUT = "//" + HOST_NAME + "/udbweb/logout/" + APPID;
}
var WEIBO_APPKEY = window.location.hostname === 'yy.duowan.com' ? '1690793979' : '2822259651';
var IFRAME_URL = {
    QQ: "https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101163067&redirect_uri=" + encodeURIComponent(INTERFACE.QQ_CB),
    WB: "https://api.weibo.com/oauth2/authorize?client_id=" + WEIBO_APPKEY + "&response_type=code&redirect_uri=" + encodeURIComponent(INTERFACE.WB_CB),
    WX: "https://open.weixin.qq.com/connect/qrconnect?appid=wxbc92ea88a894bfe9&redirect_uri=" + encodeURIComponent(INTERFACE.WX_CB) + "&response_type=code&scope=snsapi_login&style=white"
};
var SDK = {
    XP_LOAD_SCRIPT: 'https://ulink.yy.com/js/beforeLoginSha2Check.js',
    UDB_SDK: '//res.udb.duowan.com/lgn/js/oauth/udbsdk/pcweb/udb.sdk.pcweb.embed.min.js',
    UDB_SDK2: '//res.udb.duowan.com/lgn/js/oauth/udbsdk/udb.sdk.getmm.min.js'
};
var cache = {
    onReadyFns: [],
    loginCb: undefined
};
var ETabs;
(function (ETabs) {
    ETabs["LOGIN"] = "login";
    ETabs["REG"] = "reg";
})(ETabs || (ETabs = {}));
var ELoginType;
(function (ELoginType) {
    ELoginType["DEFAULT"] = "";
    ELoginType["COMMON"] = "commonLogin";
    ELoginType["QUICK"] = "quickLogin";
    ELoginType["QRCODE"] = "qrLogin";
    ELoginType["VERIFY"] = "loginVerify";
    ELoginType["CA_VERIFY"] = "caVerify";
})(ELoginType || (ELoginType = {}));
var ERegType;
(function (ERegType) {
    ERegType["DEFAULT"] = "phoneReg";
    ERegType["PHONE"] = "phoneReg";
    ERegType["EMAIL"] = "emailReg";
})(ERegType = exports.ERegType || (exports.ERegType = {}));
function clearBBSCookies() {
    util_1.cookies.keys().forEach(function (key) {
        if (key.startsWith('bbs_') || key.startsWith('CHrt_')) {
            util_1.cookies.erase(key, '/', '.yy.com');
        }
    });
}
exports.clearBBSCookies = clearBBSCookies;
var handle;
var Udb = (function (_super) {
    __extends(Udb, _super);
    function Udb(props) {
        var _this = _super.call(this, props) || this;
        _this.phoneRegFrame = React.createRef();
        _this.emailRegFrame = React.createRef();
        _this.state = {
            show: false,
            the3rdShow: false,
            sdkReady: false,
            loginReady: false,
            currentTab: ETabs.LOGIN,
            loginType: ELoginType.DEFAULT,
            regType: ERegType.DEFAULT,
            regEmailUrl: '',
            regPhoneUrl: '',
            thirdpartyUrl: '',
            accept: true,
            regReady: false
        };
        handle = _this;
        _this.initUdb()["catch"](function () { return undefined; });
        _this.initPostMessage();
        return _this;
    }
    Udb.prototype.render = function () {
        var _a = this.state, show = _a.show, currentTab = _a.currentTab, the3rdShow = _a.the3rdShow, loginType = _a.loginType, regType = _a.regType, accept = _a.accept, regEmailUrl = _a.regEmailUrl, regPhoneUrl = _a.regPhoneUrl, thirdpartyUrl = _a.thirdpartyUrl;
        var ModLogin = (React.createElement("div", { id: "login-tab", className: "login-tab_" + APPID },
            React.createElement("div", { id: "udbsdk_login_content" }),
            loginType === ELoginType.COMMON && (React.createElement("div", { className: "login-footer" },
                React.createElement("div", { className: "login-footer-content active", id: "commonLogin" },
                    React.createElement("div", { className: "login-footer-ctrl" },
                        React.createElement("a", { className: "tab-btn", href: "https://aq.yy.com/p/pwd/fgt/index.do", target: "_blank" }, "\u5FD8\u8BB0\u5BC6\u7801"),
                        React.createElement("span", null, "|"),
                        React.createElement("a", { className: "tab-btn active", onClick: this.reg.bind(this, ERegType.DEFAULT) }, "\u6CE8\u518C")),
                    React.createElement("div", { className: "login-footer-thirdparty" },
                        React.createElement("a", { className: "qqlogin", href: "javascript:;", onClick: this.qqLogin.bind(this) }),
                        React.createElement("a", { className: "wxlogin", href: "javascript:;", onClick: this.wxLogin.bind(this) }),
                        React.createElement("a", { className: "wblogin", href: "javascript:;", onClick: this.wbLogin.bind(this) }))))),
            loginType === ELoginType.QUICK && (React.createElement("div", { className: "login-footer" },
                React.createElement("div", { className: "login-footer-content active", id: "quickLogin" },
                    React.createElement("div", { className: "login-footer-ctrl" },
                        React.createElement("a", { className: "tab-btn active", onClick: this.reg.bind(this, ERegType.DEFAULT) }, "\u6CE8\u518C")),
                    React.createElement("div", { className: "login-footer-thirdparty" },
                        React.createElement("a", { className: "qqlogin", href: "javascript:;", onClick: this.qqLogin.bind(this) }),
                        React.createElement("a", { className: "wxlogin", href: "javascript:;", onClick: this.wxLogin.bind(this) }),
                        React.createElement("a", { className: "wblogin", href: "javascript:;", onClick: this.wbLogin.bind(this) }))))),
            loginType === ELoginType.QRCODE && (React.createElement("div", { className: "login-footer" },
                React.createElement("div", { className: "login-footer-content active", id: "qrLogin" },
                    React.createElement("div", { className: "login-footer-ctrl" },
                        React.createElement("a", { className: "tab-btn active", onClick: this.switchLoginType.bind(this, ELoginType.COMMON) }, "\u8D26\u53F7\u5BC6\u7801\u767B\u5F55"),
                        React.createElement("span", null, "|"),
                        React.createElement("a", { className: "tab-btn", onClick: this.reg.bind(this, ERegType.DEFAULT) }, "\u6CE8\u518C"))))),
            loginType === ELoginType.VERIFY && (React.createElement("div", { className: "login-footer" },
                React.createElement("div", { className: "login-footer-content active", id: "loginVerify" },
                    React.createElement("div", { className: "login-footer-ctrl" },
                        React.createElement("a", { className: "tab-btn", href: "https://aq.yy.com/p/pwd/fgt/index.do", target: "_blank" }, "\u5FD8\u8BB0\u5BC6\u7801"),
                        React.createElement("span", null, "|"),
                        React.createElement("a", { className: "tab-btn active", onClick: this.reg.bind(this, ERegType.DEFAULT) }, "\u6CE8\u518C")),
                    React.createElement("div", { className: "login-footer-thirdparty" },
                        React.createElement("a", { className: "qqlogin", href: "javascript:;", onClick: this.qqLogin.bind(this) }),
                        React.createElement("a", { className: "wxlogin", href: "javascript:;", onClick: this.wxLogin.bind(this) }),
                        React.createElement("a", { className: "wblogin", href: "javascript:;", onClick: this.wbLogin.bind(this) }))))),
            loginType === ELoginType.CA_VERIFY && (React.createElement("div", { className: "login-footer" },
                React.createElement("div", { className: "login-footer-content active", id: "caVerify" },
                    React.createElement("div", { className: "login-footer-thirdparty" },
                        React.createElement("a", { className: "qqlogin", href: "javascript:;", onClick: this.qqLogin.bind(this) }),
                        React.createElement("a", { className: "wxlogin", href: "javascript:;", onClick: this.wxLogin.bind(this) }),
                        React.createElement("a", { className: "wblogin", href: "javascript:;", onClick: this.wbLogin.bind(this) })))))));
        var ModReg = (React.createElement(React.Fragment, null,
            React.createElement("a", { className: "gotologin-corner", title: "\u767B\u5F55", onClick: this.login.bind(this) }),
            React.createElement("div", { className: "title  phone-title " + (regType === ERegType.PHONE ? 'active' : '') }, "\u624B\u673A\u6CE8\u518C"),
            React.createElement("div", { className: "register-tab " + (regType === ERegType.PHONE ? 'active' : '') },
                React.createElement("iframe", { id: "register-phone", frameBorder: "0", scrolling: "no", ref: this.phoneRegFrame, src: regPhoneUrl }),
                React.createElement("div", { className: "toggle" },
                    React.createElement("a", { className: "use-email", href: "javascript:;", onClick: this.reg.bind(this, ERegType.EMAIL) }, "\u4F7F\u7528\u90AE\u7BB1\u6CE8\u518C"))),
            React.createElement("div", { className: "title email-title " + (regType === ERegType.EMAIL ? 'active' : '') }, "\u90AE\u7BB1\u6CE8\u518C"),
            React.createElement("div", { className: "register-tab " + (regType === ERegType.EMAIL ? 'active' : '') },
                React.createElement("iframe", { id: "register-email", frameBorder: "0", scrolling: "no", ref: this.emailRegFrame, src: regEmailUrl }),
                React.createElement("div", { className: "toggle" },
                    React.createElement("a", { className: "use-email", href: "javascript:;", onClick: this.reg.bind(this, ERegType.PHONE) }, "\u4F7F\u7528\u624B\u673A\u6CE8\u518C"))),
            React.createElement("div", { className: "register-footer" },
                React.createElement("div", { className: "protocol" },
                    React.createElement("p", null,
                        React.createElement("input", { type: "checkbox", id: "accept", checked: accept, onChange: this.onAcceptChange.bind(this) }),
                        React.createElement("label", { htmlFor: "accept" },
                            "\u6CE8\u518C\u524D\u8BF7\u9605\u8BFB",
                            React.createElement("a", { href: "//zc.yy.com/license.html", target: "_blank" }, "\u300A\u7528\u6237\u6CE8\u518C\u534F\u8BAE\u300B"),
                            React.createElement("a", { href: "http://www.huanju.cn/1207/m_205349693256.html", target: "_blank" }, "\u300A\u9690\u79C1\u534F\u8BAE\u300B")))),
                React.createElement("div", { className: "gotologin-link", onClick: this.login.bind(this) }, "\u767B\u5F55"))));
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: "thirdparty-frame-box", className: "" + (the3rdShow ? 'show' : '') },
                React.createElement("a", { className: "close", href: "javascript:;", onClick: this.hide3rd.bind(this) }),
                React.createElement("a", { className: "back", href: "javascript:;", onClick: this.hide3rd.bind(this) }),
                React.createElement("iframe", { id: "thirdpartyLoginFrame", scrolling: "no", frameBorder: 0, src: thirdpartyUrl })),
            React.createElement("div", { className: "login-box " + (show ? 'show' : '') },
                React.createElement("a", { className: "close", href: "javascript:;", onClick: this.hide.bind(this) }),
                React.createElement("div", { className: "login-bd" },
                    React.createElement("div", { className: "login-content" },
                        React.createElement("div", { className: "tab-unit " + (currentTab === ETabs.LOGIN ? 'active' : '') }, ModLogin),
                        React.createElement("div", { className: "tab-unit register-block " + (currentTab === ETabs.REG ? 'active' : '') }, ModReg)))),
            React.createElement("div", { className: "account-login-mask " + (show ? 'show' : '') })));
    };
    Udb.prototype.initUdb = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!window.UDB) return [3, 2];
                        return [4, util_1.getScript(SDK.UDB_SDK)];
                    case 1:
                        _a.sent();
                        window.UDB.sdk.PCWeb.initialize();
                        this.setState({
                            sdkReady: true
                        }, function () {
                            cache.onReadyFns.forEach(function (fn) {
                                fn();
                            });
                            cache.onReadyFns = [];
                        });
                        _a.label = 2;
                    case 2:
                        if (!!window.getMC) return [3, 4];
                        return [4, util_1.getScript(SDK.UDB_SDK2)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!(!IS_WIN && IS_WIN_XP)) return [3, 6];
                        return [4, util_1.getScript(SDK.XP_LOAD_SCRIPT)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        if (util_1.getParameterByName('regSuccess') === 'true') {
                            stat_1.stat(stat_1.EStatType.UDB_REG_SUCCESS);
                        }
                        window.loginSuccess = function () {
                            _this.hide()["catch"](function () { return undefined; });
                            stat_1.stat(stat_1.EStatType.UDB_LOGIN_SUCCESS);
                            cache.loginCb && cache.loginCb();
                            window.header.logStateChange();
                        };
                        return [2];
                }
            });
        });
    };
    Udb.prototype.fetchAuth = function () {
        return __awaiter(this, void 0, void 0, function () {
            var start, rs, er_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        start = +new Date();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, then_ajax_1.thenPost(INTERFACE.GET_AUTH)];
                    case 2:
                        rs = _a.sent();
                        stat_1.metrics(stat_1.EMetricsType.LOGIN_AUTH, {
                            cost: +new Date() - start,
                            code: rs.success === 1 ? 0 : 'ajax_error'
                        });
                        return [2, rs];
                    case 3:
                        er_1 = _a.sent();
                        stat_1.metrics(stat_1.EMetricsType.LOGIN_AUTH, {
                            cost: +new Date() - start,
                            code: 'ajax_error'
                        });
                        return [2, ''];
                    case 4: return [2];
                }
            });
        });
    };
    Udb.prototype.initLoginFrame = function () {
        return __awaiter(this, void 0, void 0, function () {
            var udbLoginStr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.fetchAuth()];
                    case 1:
                        udbLoginStr = _a.sent();
                        window.UDB.sdk.PCWeb.initialize();
                        window.UDB.sdk.PCWeb.embedOpenLgn(udbLoginStr, INTERFACE.LOGIN_CB);
                        this.setState({
                            loginReady: true
                        });
                        return [2];
                }
            });
        });
    };
    Udb.prototype.initRegFrame = function (type) {
        var _this = this;
        var _a = window.header, ref = _a.ref, cpuid = _a.cpuid;
        var sid = 0;
        if (window.pageInfo && window.pageInfo.sid) {
            sid = window.pageInfo.sid;
        }
        var STATISTICS_FROM_ADV = "yy_" + ref + ".cpuid_" + cpuid + ".channel_" + sid;
        var regEmailUrl = "https://zc.yy.com/reg/udb/reg4udb.do?appid=5719&action=3&type=Email&mode=udb&fromadv=" + STATISTICS_FROM_ADV + "&busiurl=" + encodeURIComponent(INTERFACE.REG_CB);
        var regPhoneUrl = "https://zc.yy.com/reg/udb/reg4udb.do?appid=5719&action=3&type=Mobile&mode=udb&fromadv=" + STATISTICS_FROM_ADV + "&busiurl=" + encodeURIComponent(INTERFACE.REG_CB);
        return new Promise(function (next) {
            _this.setState({
                regReady: true,
                regEmailUrl: type === ERegType.EMAIL ? regEmailUrl : '',
                regPhoneUrl: type === ERegType.PHONE ? regPhoneUrl : ''
            }, function () {
                next();
            });
        });
    };
    Udb.prototype.initPostMessage = function () {
        var _this = this;
        window.addEventListener('message', function (event) {
            var origin = event.origin;
            if ((origin.indexOf('lgn.yy.com') === -1 &&
                origin.indexOf('zc.yy.com') === -1) ||
                typeof event.data !== 'string') {
                return;
            }
            var data = event.data.split('|');
            switch (data[0]) {
                case 'report':
                    if (data[1] === stat_1.EStatType.UDB_QR_CLICK) {
                        stat_1.stat(stat_1.EStatType.UDB_QR_CLICK);
                    }
                    else if (data[1] === stat_1.EStatType.UDB_SCAN_SUCCESS) {
                        stat_1.stat(stat_1.EStatType.UDB_SCAN_SUCCESS);
                    }
                    else if (data[1] === stat_1.EStatType.UDB_QR_LOGIN_SUCCESS) {
                        stat_1.stat(stat_1.EStatType.UDB_QR_LOGIN_SUCCESS);
                    }
                    break;
                case 'beforeShowType':
                    break;
                case 'showType':
                    if (data[1] === ELoginType.COMMON) {
                        _this.updateLoginType(ELoginType.COMMON);
                    }
                    else if (data[1] === ELoginType.CA_VERIFY) {
                        _this.updateLoginType(ELoginType.CA_VERIFY);
                    }
                    else if (data[1] === ELoginType.QUICK) {
                        _this.updateLoginType(ELoginType.QUICK);
                    }
                    else if (data[1] === ELoginType.QRCODE) {
                        _this.updateLoginType(ELoginType.QRCODE);
                    }
                    else if (data[1] === ELoginType.VERIFY) {
                        _this.updateLoginType(ELoginType.VERIFY);
                    }
                    break;
                case 'onRegLoad':
                    _this.syncAcceptStateToFrame();
                    break;
            }
        }, false);
    };
    Udb.prototype.login = function (done) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.state.sdkReady) return [3, 2];
                        return [4, util_1.makeAwait(function (next) {
                                cache.onReadyFns.push(function () {
                                    next();
                                });
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4, this.initLoginFrame()];
                    case 3:
                        _a.sent();
                        this.switchTab(ETabs.LOGIN);
                        return [4, util_1.makeAwait(function (next) {
                                cache.loginCb = function () {
                                    next();
                                };
                            })];
                    case 4:
                        _a.sent();
                        if (done) {
                            done();
                        }
                        return [2];
                }
            });
        });
    };
    Udb.prototype.logout = function (uid) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clearBBSCookies();
                        return [4, then_ajax_1.thenGet(INTERFACE.LOGOUT, { uid: uid })];
                    case 1:
                        data = _a.sent();
                        if (!data.deleteCookieURL) return [3, 3];
                        return [4, util_1.makeAwait(function (next) {
                                try {
                                    window.UDB.sdk.PCWeb.deleteCrossmainCookieWithCallBack(data.deleteCookieURL, next);
                                }
                                catch (er) {
                                    next();
                                }
                            })];
                    case 2:
                        _a.sent();
                        window.header.logStateChange();
                        return [2];
                    case 3: throw new Error('退出失败');
                }
            });
        });
    };
    Udb.prototype.reg = function (type) {
        if (type === void 0) { type = ERegType.DEFAULT; }
        return __awaiter(this, void 0, void 0, function () {
            var regReady;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        regReady = this.state.regReady;
                        return [4, this.initRegFrame(type)];
                    case 1:
                        _a.sent();
                        this.switchTab(ETabs.REG);
                        this.switchRegType(type);
                        return [2];
                }
            });
        });
    };
    Udb.prototype.switchTab = function (type) {
        this.setState({
            show: true,
            currentTab: type
        });
    };
    Udb.prototype.updateLoginType = function (type) {
        this.setState({
            loginType: type
        });
    };
    Udb.prototype.switchLoginType = function (type) {
        var LoginIframe = document.getElementById('udbsdk_frm_normal');
        if (LoginIframe && LoginIframe.contentWindow) {
            LoginIframe.contentWindow.postMessage(type, '*');
        }
    };
    Udb.prototype.switchRegType = function (type) {
        this.setState({
            regType: type
        });
    };
    Udb.prototype.onAcceptChange = function (e) {
        var _this = this;
        this.setState({
            accept: e.currentTarget.checked
        }, function () {
            _this.syncAcceptStateToFrame();
        });
    };
    Udb.prototype.syncAcceptStateToFrame = function () {
        var accept = this.state.accept;
        var acceptType = accept ? '1' : '0';
        var msgStr = "setLicenceStatus|" + acceptType;
        var emailFrameEl = this.emailRegFrame.current;
        var phoneFrameEl = this.phoneRegFrame.current;
        if (emailFrameEl.contentWindow) {
            emailFrameEl.contentWindow.postMessage(msgStr, '*');
        }
        if (phoneFrameEl.contentWindow) {
            phoneFrameEl.contentWindow.postMessage(msgStr, '*');
        }
    };
    Udb.prototype.qqLogin = function () {
        this.setState({
            thirdpartyUrl: IFRAME_URL.QQ,
            the3rdShow: true
        });
    };
    Udb.prototype.wxLogin = function () {
        this.setState({
            thirdpartyUrl: IFRAME_URL.WX,
            the3rdShow: true
        });
    };
    Udb.prototype.wbLogin = function () {
        this.setState({
            thirdpartyUrl: IFRAME_URL.WB,
            the3rdShow: true
        });
    };
    Udb.prototype.hide = function () {
        var _this = this;
        return new Promise(function (next) {
            _this.setState({
                show: false,
                the3rdShow: false,
                thirdpartyUrl: '',
                regEmailUrl: '',
                regPhoneUrl: ''
            }, function () {
                next();
            });
        });
    };
    Udb.prototype.hide3rd = function () {
        this.setState({
            the3rdShow: false,
            thirdpartyUrl: ''
        });
    };
    return Udb;
}(React.Component));
exports.Udb = Udb;
function init() {
    var udbEl = document.getElementById(UDB_EL_ID);
    if (!udbEl) {
        udbEl = document.createElement('div');
        udbEl.id = UDB_EL_ID;
        document.body.appendChild(udbEl);
    }
    ReactDom.render(React.createElement(Udb, null), udbEl);
}
function login(done) {
    return handle.login(done);
}
exports.login = login;
function logout(uid) {
    return handle.logout(uid);
}
exports.logout = logout;
function hide() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, handle.hide()];
        });
    });
}
exports.hide = hide;
function register() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, handle.reg(ERegType.DEFAULT)];
        });
    });
}
exports.register = register;
exports.udb = {
    login: login,
    register: register,
    hide: hide,
    logout: logout
};
init();
